import { animate, keyframes, state, style, transition, trigger } from '@angular/animations';
import { Component } from '@angular/core';
import { Toast } from 'ngx-toastr';

@Component({
    selector: 'lsq-toast',
    template: `
        <button
            *ngIf="options.closeButton"
            (click)="remove()"
            class="toast-close-button"
            aria-label="Close"
        >
            <span aria-hidden="true">&times;</span>
        </button>
        <div *ngIf="title" [class]="options.titleClass" [attr.aria-label]="title">
            {{ title }}
        </div>
        <div
            *ngIf="message && options.enableHtml"
            role="alertdialog"
            aria-live="polite"
            [class]="options.messageClass"
            [innerHTML]="message"
        ></div>
        <div
            *ngIf="message && !options.enableHtml"
            role="alertdialog"
            aria-live="polite"
            [class]="options.messageClass"
            [attr.aria-label]="message"
        >
            {{ message }}
        </div>
        <div *ngIf="options.progressBar">
            <div class="toast-progress" [style.width]="width + '%'"></div>
        </div>
    `,
    styleUrls: ['lsq-toast.component.scss'],
    animations: [
        trigger('flyInOut', [
            state(
                'closed',
                style({
                    display: 'none',
                    opacity: 0
                })
            ),
            transition(
                'inactive => active',
                animate(
                    '500ms ease-out',
                    keyframes([
                        style({
                            transform: 'translate3d(100%, 0, 0) skewX(-30deg)',
                            opacity: 0
                        }),
                        style({
                            transform: 'skewX(20deg)',
                            opacity: 1
                        }),
                        style({
                            transform: 'skewX(-5deg)',
                            opacity: 1
                        }),
                        style({
                            transform: 'none',
                            opacity: 1
                        })
                    ])
                )
            ),
            transition(
                'active => removed',
                animate(
                    '500ms ease-out',
                    keyframes([
                        style({
                            opacity: 1
                        }),
                        style({
                            transform: 'translate3d(100%, 0, 0)',
                            opacity: 0
                        })
                    ])
                )
            )
        ])
    ]
})
export class LsqToastComponent extends Toast {}
